import styled from 'styled-components';
import { Box } from '@material-ui/core';

const UserNameText = styled(Box)`
  font-family: Lato, sans-serif;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #FFF;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export default UserNameText;
